import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  products: [],
  filtered: [],
  searchTerm: '',
  subCategoryId: 'All',
  subCategories: [],
  visibleCount: 20,
  scrollLoading: false,
  hasMore: true,
  isAtStart: true,
  isAtEnd: false,
  showScrollUp: false,
  showScrollDown: false,
  openModal: false,
  openCartModal: false,
  loading: false,
};

const cakeProductSlice = createSlice({
  name: 'cakeProduct',
  initialState,
  reducers: {
    setProducts: (state, action) => {
      state.products = action.payload;
      state.filtered = action.payload;
    },
    setFiltered: (state, action) => {
      state.filtered = action.payload;
      state.visibleCount = 20;
      state.hasMore = action.payload.length > 20;
    },
    setSearchTerm: (state, action) => {
      state.searchTerm = action.payload;
    },
    setSubCategoryId: (state, action) => {
      state.subCategoryId = action.payload;
    },
    setSubCategories: (state, action) => {
      state.subCategories = action.payload;
    },
    setVisibleCount: (state, action) => {
      state.visibleCount = action.payload;
    },
    setScrollLoading: (state, action) => {
      state.scrollLoading = action.payload;
    },
    setHasMore: (state, action) => {
      state.hasMore = action.payload;
    },
    setIsAtStart: (state, action) => {
      state.isAtStart = action.payload;
    },
    setIsAtEnd: (state, action) => {
      state.isAtEnd = action.payload;
    },
    setShowScrollUp: (state, action) => {
      state.showScrollUp = action.payload;
    },
    setShowScrollDown: (state, action) => {
      state.showScrollDown = action.payload;
    },
    setOpenModal: (state, action) => {
      state.openModal = action.payload;
    },
    setOpenCartModal: (state, action) => {
      state.openCartModal = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    addProduct: (state, action) => {
      const newProduct = action.payload;
      state.products = [...state.products, newProduct];
      state.filtered = [...state.filtered, newProduct];
    },
  },
});

export const {
  setProducts,
  setFiltered,
  setSearchTerm,
  setSubCategoryId,
  setSubCategories,
  setVisibleCount,
  setScrollLoading,
  setHasMore,
  setIsAtStart,
  setIsAtEnd,
  setShowScrollUp,
  setShowScrollDown,
  setOpenModal,
  setOpenCartModal,
  setLoading,
  addProduct,
} = cakeProductSlice.actions;

export default cakeProductSlice.reducer;